/*
 * @Description:
 * @Autor: xiaona.wang
 * @Date: 2021-07-22 17:11:59
 * @LastEditors: yingna.gao
 * @LastEditTime: 2022-09-29 15:58:14
 */
import router from "./router";
import store from "./store";
import { Message } from "element-ui";
import NProgress from "nprogress"; // progress bar
import "nprogress/nprogress.css"; // progress bar style
/* import { getLang, getToken } from "@/utils/auth";*/ // get token from cookie
/* import getPageTitle from "@/utils/get-page-title";*/
import { checkIsMircApp } from "@/utils/mircApp";
import i18n from "@/assets/lang";
import defaultSettings from "@/settings";
import SocketService, { attachmentDownload, attachmentNotify, attachmentImport } from "@/utils/socket_service";

NProgress.configure({ showSpinner: false }); // NProgress Configuration

const whiteList = ["/login", "/getBackPassword"]; // no redirect whitelist

const getPageTitle = function getPageTitle(key) {
  const title = i18n.t(`title.${defaultSettings.title}`);
  const hasKey = i18n.te(`route.${key}`);
  if (hasKey) {
    const pageName = i18n.t(`route.${key}`);
    return `${pageName} - ${title}`;
  }
  return `${title}`;
};

router.beforeEach(async(to, from, next) => {
  // start progress bar
  NProgress.start();
  // glo_loading.loadingShow();
  if(to.path==="/login"){
    await store.dispatch("user/resetToken");
  }
  // set page title
  document.title = getPageTitle(to.meta.title);

  /*
   *  // determine whether the user has logged in
   * const hasToken = getToken();
   * 设置白名单信息
   */
  if (whiteList.indexOf(to.path) !== -1) {
    //   // in the free login whitelist, go directly
    next();
  } else {
    const hasGetUserInfo = store.getters.userInfo;
    const { routes = [] } = store.getters;
    // 存在用户和路由正常走
    if (Object.keys(hasGetUserInfo).length !== 0 && routes.length !== 0) {
      // 跳转到一级主菜单需要区分是否需要tag
      if (to.matched.length === 0) {
        if (checkIsMircApp(to.path)) {
          // 子应用内部路由不走404，不要处理，子应用自己的路由会自己跳转
          NProgress.done();
        } else {
          next("/404");
        }

        /*
         * to.query.hasPush = true;
         * next(to);
         */
      } else {
        next();
      }
    } else {
      // 第一次进入系统获取用户角色和路由等信息
      try {
        // get user info
        const { roles } = await store.dispatch("user/getInfo");
        // 开启socket
        SocketService.Instance.connect();
        SocketService.instance.callBackMapping = {};
        // SocketService.instance.registerCallBack({ key: 'export', callBack: attachmentDownload });
        SocketService.instance.registerCallBack({ key: "notify", callBack: attachmentNotify });
        SocketService.instance.registerCallBack({ key: "import", callBack: attachmentImport });
        // 判断是否有角色信息，有则获取菜单详情，没有提示请联系管理员，跳转到登录
        // if (roles && roles.length > 0) {
        // 获取logo信息
        await store.dispatch("user/getTitle");
        // 获取用户设置信息
        await store.dispatch("settings/getSetting");
        // generate accessible routes map based on roles

        const accessRoutes = await store.dispatch("permission/generateRoutes", roles);
        // dynamically add accessible routes
        router.addRoutes(accessRoutes);
        if (to.query && to.query.noredirect) {
          next({ ...to, replace: true });
        } else {
          window.location.href = `${window.location.origin}/#/dashboard`;
          next({ path: "/dashboard", replace: true });
          // next({ ...to, replace: true });
        }

        /*
           *  next({ ...to, replace: true });
           * next({ path: "/org-new/org-new-list", replace: true });
           * next({ path: "/user-new/user-new-list", replace: true });
           */
        // } else {
        //   // 角色不存在跳转到登录页面
        //   await store.dispatch('user/resetToken');
        //   next(`/login`);
        //   NProgress.done();
        //   Message.error('请联系管理员分配角色');
        // }
      } catch (error) {
        // remove token and go to login page to re-login
        await store.dispatch("user/resetToken");
        next(`/login`);
        NProgress.done();
        // glo_loading.loadingHide();
      }
    }
  }

  // }
  // }
  // } else {
  //   /* has no token*/
  //   debugger;
  //   if(whiteList.indexOf(to.path) !== -1) {
  //   // in the free login whitelist, go directly
  //   next();
  // } else {
  //   // other pages that do not have permission to access are redirected to the login page.
  //   next(`/login`);
  //   NProgress.done();
  //   //glo_loading.loadingHide();
  // }
  //   }
});

router.afterEach(() => {
  // finish progress bar
  NProgress.done();
  // glo_loading.loadingHide();
});
